import React from "react";
import { Layout, SkeletonPage } from "@shopify/polaris";
import { HomeSkeletonCard } from "./HomeSkeletonCard";

export function HomeIndexPageSkeleton(): React.JSX.Element {
  return (
    <SkeletonPage narrowWidth>
      <Layout>
        <Layout.Section variant="fullWidth">
          <HomeSkeletonCard />
        </Layout.Section>
        <Layout.Section variant="fullWidth">
          <HomeSkeletonCard />
        </Layout.Section>
        <Layout.Section variant="fullWidth">
          <HomeSkeletonCard />
        </Layout.Section>
      </Layout>
    </SkeletonPage>
  );
}
